module.exports = __webpack_public_path__ + "img/34.ce486b39.webp";